import { apiRequest} from './index'

export const generateUnitExportRequest = (projectId) => {
	return apiRequest(
    `/admin/exports/unit?projectId=${projectId}`,
    {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json; charset=utf-8'
			},
			responseType: 'blob',
    },
    true
	)
}